module.exports = __webpack_public_path__ + "img/eye.42959bfe.svg";